var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.setup}},[(_vm.coverContent)?_c('section',{staticClass:"cover show",attrs:{"id":"cover-page"}},[_c(_vm.dynComponent,{tag:"component"})],1):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-407a252b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cover.vue
// module id = 558
// module chunks = 1